import { useStudentContext } from "context/StudentContext";

const useSelectedStudent = () => {
    return useStudentContext();
};

export default useSelectedStudent;
